import { UserCog } from "lucide-react";

export default function KullaniciAyarlari() {
  return (
    <div className="space-y-5 max-w-3xl" data-testid="page-kullanici-ayarlari">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <UserCog className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Kullanıcı Ayarları</h1>
          <p className="text-xs text-slate-500">Hesap ve yetki bilgileri</p>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl p-6 shadow-sm border border-slate-100 dark:border-slate-800 space-y-5">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#F0651E] to-[#F5A03E] flex items-center justify-center text-white text-2xl font-extrabold">SZ</div>
          <div>
            <div className="text-lg font-extrabold">Sezar Admin</div>
            <span className="inline-block mt-1 px-2.5 py-0.5 rounded-full bg-orange-100 dark:bg-orange-900/30 text-[#F0651E] text-xs font-bold">YÖNETİCİ</span>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { l: "Kullanıcı Adı", v: "sezar.admin" },
            { l: "E-posta", v: "admin@littlecaesarspizzas.com" },
            { l: "Rol", v: "Süper Admin" },
            { l: "Son Giriş", v: "16.07.2026 14:01" },
          ].map((f) => (
            <div key={f.l}>
              <label className="text-xs font-semibold text-slate-500">{f.l}</label>
              <input readOnly defaultValue={f.v} className="w-full mt-1 rounded-xl border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 px-4 py-2.5 text-sm font-medium" />
            </div>
          ))}
        </div>
        <div className="flex items-center justify-between rounded-xl border border-slate-200 dark:border-slate-700 p-4">
          <div>
            <div className="font-semibold text-sm">İki Adımlı Doğrulama</div>
            <div className="text-xs text-slate-500">Hesap güvenliği için önerilir</div>
          </div>
          <div className="w-11 h-6 rounded-full bg-[#F0651E] relative"><span className="absolute right-0.5 top-0.5 w-5 h-5 bg-white rounded-full" /></div>
        </div>
        <button className="rounded-xl bg-[#F0651E] px-5 py-2.5 text-sm font-bold text-white hover:bg-[#d9560f]">Değişiklikleri Kaydet</button>
      </div>
    </div>
  );
}
